/**
 * @Author ytyjm
 * @Create Time 2020/3/23
 * @Description: 所有接口请求
 */

// eslint-disable-next-line no-unused-vars
import { getRequest, postRequest } from './request'
const codeUrl=process.env.VUE_APP_BASE_Common_API
/* 登录注册 */
// export const login = data => postRequest('/login', data)
// export const register = data => getRequest('/register', data)

// export const xxx = data => deleteRequest('/xxx', data)
// export const xxx = data => putRequest('/xxx', data)

/* 文章接口 */
/**
 * 用户是否开通钱包
 * @param data
 * @returns {res.data}
 */
export const getActStatus=data=>postRequest('/activity/common/walletStatus',data)

export const isVaildActivity=data=>postRequest('/coin/isVaildActivity',data)

/**
 * 获取该用户能量信息
 * @param data
 * @returns {res.data}
 */
export const getCoinInfo = data=>postRequest('/coin/getCoinInfo',data)


/**
 * 获取该用户能量日志列表
 * @param data
 * @returns {res.data}
 */
export const findCoinLogList = data=>postRequest('/coin/findCoinLogList',data)


/**
 * 保存被邀请人信息
 * @param data
 * @returns {res.data}
 */
export const addInviteInfo = data=>postRequest('/coin/addInviteInfo',data)


/**
 *充值失败，再次充值
 * 入参：必须登录
 orderNo-订单号
 mobileNo-充值手机号
 * @param data
 * @returns {res.data}
 */
export const recharge = data=>postRequest('/coin/recharge',data)

/**
 * .获取兑换信息
 * 入参：必须登录
 productId -产品编码
 activityNo -活动编码
 * @param data
 * @returns {res.data}
 */
export const findCostLogList = data=>postRequest('/coin/findCostLogList',data)

/**
 *  使用能量，兑换奖品
 *  入参：必须登录
 * productId -
 * activityNo -活动编码
 * productName -产品名称（例如：5元话费券）
 * mobileNo -手机号（充值手机号，可为空）
 * @param data
 * @returns {res.data}
 */
export const costCoin = data=>postRequest('/coin/costCoin',data)


export const postSendCode = data=>postRequest( `${codeUrl}MetroMessage/SendMsg.do?fbnb=nss`,data)








